import { createFileRoute } from '@tanstack/react-router'
import { ReportPage, reportSearches } from '@/features/analytics/index.ts'
import { usePersistedListQuery } from '@/hooks/use-persisted-list-query.ts'

const persistence = reportSearches.business
export const Route = createFileRoute('/_authenticated/reports/businesses')({
  validateSearch: persistence.validateSearch,
  beforeLoad: (options) => persistence.restore(options),
  component: Page,
  head: () => ({ meta: [{ title: '业务分析 · Super Mega' }] })
})
function Page() {
  const { currentSession } = Route.useRouteContext()
  const { search, navigateSearch } = usePersistedListQuery({
    persistence,
    raw: Route.useSearch(),
    accountId: currentSession.id,
    navigate: Route.useNavigate()
  })
  return <ReportPage dimension="business" search={search} navigate={navigateSearch} />
}
